<div class="container">
    <div class="float-right">
        <ul class="list-inline">
            <li><a [routerLink]="['/legalpage/accessadvice']"><span translate="LegalPage.AccessAdviceLink"></span></a></li>
            <li><a [routerLink]="['/legalpage/cookies']"><span translate="LegalPage.CookiesLink"></span></a></li>
            <li><a [routerLink]="['/legalpage/privacypolicy']"><span translate="LegalPage.PrivacyPolicyLink"></span></a></li>
            <li><a [routerLink]="['/legalpage/termsofuse']"><span translate="LegalPage.TermsOfUseLink"></span></a></li>
        </ul>
    </div>
</div>